__turbopack_context__.v({
  "body": "ConnectConsultantModal-module-scss-module__10QeoG__body",
  "overlay": "ConnectConsultantModal-module-scss-module__10QeoG__overlay",
});
